import { render, staticRenderFns } from "./MeasurementList.vue?vue&type=template&id=5f065bdb&"
import script from "./MeasurementList.vue?vue&type=script&lang=js&"
export * from "./MeasurementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports